module.exports = __webpack_public_path__ + "static/media/rocket.85516a7a.svg";